import React from 'react'
import useCurriculumElementsStructure from '../../../../../hooks/curriculum/useCurriculumElementsStructure';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import Loading from '../../../../Loading/Loading';
import List from './List/List';

const ElementsStructure = () => {
  const { isLoadingList } = useCurriculumElementsStructure()
  const elementsStructure = useSelector((state) => state?.curriculum?.elementsStructure || {});

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky left-0 top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>Structure</Typography>
      </Box>
      <Box className='px-2 py-2'>
        { isLoadingList
          ? <div className='absolute inset-0'>
            <Loading />
          </div> 
          : <List data={elementsStructure} />
        }
      </Box>
    </>
  )
}

export default ElementsStructure